module.exports = __webpack_public_path__ + "static/media/06-print-ad.e54ce380.png";